<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="carstats-card-header" class="pl-2 pr-3 small">
        <b-row>
          <b-col>Cars Invoiced By Event</b-col>
          <b-col cols="12" md="5">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-clock"></i>
              </template>
              <b-dropdown-item
                v-for="timerange in timeranges"
                :key="timerange"
                @click="handleUpdate(timerange)"
                >{{ timerange }}</b-dropdown-item
              >
            </b-dropdown>
            <div class="mb-0 text-right pr-4">In the last: {{ timerange }}</div>
          </b-col></b-row
        >
      </b-card-header>
      <component
        id="carbooked-chart-header"
        v-if="!timeout"
        :is="chartType + 'Chart'"
        :chartId="chartId"
        :data="chartData"
        :options="chartOptions"
      ></component>
      <div v-if="timeout" class="text-center">
        <i class="fa fa-refresh fa-5x text-danger" aria-hidden="true"></i>
        <p>{{ name }}</p>
        <p class="text-muted">
          Sorry, we've been unable to refresh the chart data whilst the feed is
          updating, we will try again soon.
        </p>
      </div>
      <b-tooltip target="carbooked-chart-header" triggers="hover"
        >A stacked bar that shows cars picked up across various events. Hover
        over a bar segment to see slac breakdown more.</b-tooltip
      >
      <b-row class="mx-1 my-2 small charttotals">
        <b-col cols="auto" class="py-2">TOTALS:</b-col>
        <section v-for="(total, index) in totals" :key="index">
          <b-col v-if="total.key == 'ALL'" cols="auto" class="py-2">
            <div>
              <span class="bg-light p-1 text-dark">{{ total.key }}</span>
              <b-badge variant="primary ml-2">{{ total.value }}</b-badge>
            </div>
          </b-col>
        </section>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import randomColor from "randomcolor";
import moment from "moment";

import HorizontalbarChart from "@/pages/private/charts/Horizontalbar-chart";
import shortid from "shortid";

export default {
  name: "CarBookedChart",
  props: ["tile", "refresh"],
  components: {
    HorizontalbarChart,
  },
  data() {
    return {
      busy: false,
      timeout: false,
      name: "Car Booked Chart",
      timerange: "90 days",
      timeranges: ["30 days", "60 days", "90 days", "180 days", "365 days"],
      chartId: shortid.generate(),
      defaultOptions: {
        horizontalbar: {
          responsive: true,
          maintainAspectRatio: true,
          tooltips: {
            enabled: true,
          },
          title: {
            display: true,
            text: "Cars Invoiced Chart",
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {},
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                  color: "#fff",
                  zeroLineColor: "#fff",
                  zeroLineWidth: 0,
                },
                ticks: {
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                stacked: true,
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                // var total = dataset.data.reduce(function (
                //   previousValue,
                //   currentValue,
                //   currentIndex,
                //   array
                // ) {
                //   return previousValue + currentValue;
                // });
                var currentValue = dataset.data[tooltipItem.index];
                if (currentValue > 0) {
                  return dataset.label + ": " + currentValue;
                } else {
                  return null;
                }
                // var percentage = currentValue; //parseFloat((currentValue / total) * 100 + 0.5).toFixed(2);

                // let raw = dataset.raw[tooltipItem.index];
                // return raw.key + " : " + raw.value;
                // return dataset.label+' '+currentValue;
                // return percentage + "%";
              },
              //   afterLabel: function(tooltipItem, data) {
              //     let raw =
              //       data.datasets[tooltipItem.datasetIndex].raw[
              //         tooltipItem.index
              //       ];
              //     // console.log(raw);
              //     return [
              //       "Name: " + raw.key,
              //       "Value: " + raw.value,
              //     ];
              //   }
            },
          },
          onClick: function (evt, item) {
            var activePoints = this.getElementsAtEvent(evt);
            var firstPoint = activePoints[0];
          },
        },
      },
      chartData: null,
      chartOptions: null,
      chartEvents: null,
      totals: [],
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    ...mapGetters(["palette", "user"]),
    chartType() {
      if (!this.tile.settings) {
        return "horizontalbar";
      }
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "horizontalbar";
      }
    },
  },
  methods: {
    async loadChart() {
      if (!this.tile.settings) return;

      let setting = null;

      this.timeout = false;
      this.busy = true;

      this.totals = [];
      let from = null;
      switch (this.timerange) {
        case "30 days":
          from = moment().add(-30, "days").format("YYYY-MM-DD");
          break;
        case "60 days":
          from = moment().add(-60, "days").format("YYYY-MM-DD");
          break;
        case "90 days":
          from = moment().add(-90, "days").format("YYYY-MM-DD");
          break;
        case "180 days":
          from = moment().add(-180, "days").format("YYYY-MM-DD");
          break;
        case "365 days":
          from = moment().add(-365, "days").format("YYYY-MM-DD");
          break;
      }

      let variables = {
        datepickupfrom: from,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query chart_carbookings($datepickupfrom: String) {
              chart_carbookings(datepickupfrom: $datepickupfrom) {
                labels
                datasets {
                  label
                  data
                }
                raw {
                  key
                  value
                }
              }
            }
          `,
          variables,
        });
        console.log(response.data.chart_carbookings);

        if (!response.data.chart_carbookings) {
          this.busy = false;
          this.timeout = true;
          return;
        }
        if (response.data.chart_carbookings.datasets.length == 0) {
          this.busy = false;
          this.timeout = true;
          return;
        }

        this.chartData = {
          labels: response.data.chart_carbookings.labels,
          datasets: response.data.chart_carbookings.datasets,
        };
        for (var i = 0; i < this.chartData.datasets.length; i++) {
          // MAKE SURE WE HAVE ENOUGH PALLETES FOR THIS ONE
          let palette = null;
          if (i < this.palette.length) {
            palette = this.palette[i];
          } else {
            let hexColor = randomColor();
            palette = {
              backgroundColor: randomColor({
                luminosity: "dark",
                format: "rgba",
                alpha: 0.1, // e.g. 'rgba(9, 1, 107, 0.5)',
              }),
              borderColor: hexColor,
              pointHoverBackgroundColor: hexColor,
              borderWidth: 2,
            };
          }
          this.chartData.datasets[i].backgroundColor = palette.borderColor;
        }

        this.totals = [];
        for (var i = 0; i < response.data.chart_carbookings.raw.length; i++) {
          if (
            response.data.chart_carbookings.raw[i].key.slice(0, 6) == "total_"
          ) {
            this.totals.push({
              key: response.data.chart_carbookings.raw[i].key.replace(
                "total_",
                ""
              ),
              value: response.data.chart_carbookings.raw[i].value,
            });
          }
        }

        // backgroundColor: this.bars.options.colors[j]

        // FIND THE DATE AND PUSH THE COLOUR
        // for (var i = 0; i < chartData.datasets.length; i++) {
        //   let colour = this.defaultOptions.palette[i];
        //   chartData.datasets[i].backgroundColor = colour.borderColor;
        // }

        // GET THE DEFAULT OPTIONS FOR THE CHART TYPE
        this.chartOptions = this.defaultOptions[this.chartType];

        let setting = null;

        setting = this.tile.settings.find((o) => o.key == "title");
        if (setting.value) {
          this.chartOptions.title = {
            display: false,
          };
          setting = this.tile.settings.find((o) => o.key == "titletext");
          if (setting) {
            // REPLACE LATER WITH FORMATTED
            let titletext = "Cars Pickups In The Last 90 days By Event";
            // let titletext = this.name + " ( " + variables.source + " )";
            if (variables.daterange) {
              titletext +=
                " " +
                this.$moment(
                  variables.daterange.split("-")[0],
                  "DD/MM/YYYY"
                ).format("MMM YYYY") +
                " slice";
            }
            this.chartOptions.title.text = titletext;
          }
        } else {
          this.chartOptions.title = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "legend");
        if (setting.value) {
          this.chartOptions.legend = {
            display: false,
          };
          setting = this.tile.settings.find((o) => o.key == "legendposition");
          if (setting) {
            this.chartOptions.legend.position = setting.value;
          }
          this.chartOptions.legend.labels = { boxWidth: 12 };
        } else {
          this.chartOptions.legend = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "datalabels");
        if (setting.value) {
          this.chartOptions.datalabels = {
            display: false,
          };
        } else {
          this.chartOptions.datalabels = {
            display: false,
          };

        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      this.timerange = update;
      await this.loadChart();
    },
  },
};
</script>

<style>
</style>